import { GitSyncProvider } from '@gitbook/api-client';
import { Icon, type SVGIconComponent } from '@gitbook/spine-icons';

/**
 * Map the Git Sync provider to an Icon
 */
export const GitSyncProviderIcon: { [type in GitSyncProvider]: SVGIconComponent } = {
    [GitSyncProvider.Github]: Icon.GitHub,
    [GitSyncProvider.Gitlab]: Icon.GitLab,
    [GitSyncProvider.GithubLegacy]: Icon.GitHub,
};
